import { TDrawer } from '../sales-models-drawer/types';

type TText = {
  name: string;
  id: ECardText;
};

type TLink = {
  name: string;
  route: string;
  id: ECardLinks;
  isLink?: boolean;
};

export type TCard = {
  index: string;
  title: string;
  texts: Array<TText>;
  list?: Array<TText>;
  links?: Array<TLink>;
  id: ECard;
  drawer?: TDrawer;
};

export type TTitleWrapper = {
  title: string;
  downloadDetailedPdf: string;
  downloadPdf: string;
};

export enum ECard {
  DECIDE_WHAT_TO_SELL = 'decideWhatToSell',
  SELECT_SALES_MODEL = 'selectSalesModel',
  REGISTER = 'register',
  RUN_AD_CAMPAIGN = 'runAdCampaign',
  UNIT_ECONOMICS = 'unitEconomics',
  ATTRACT_CUSTOMERS = 'attractCustomers',
}

export enum ECardText {
  PRODUCT_TRENDS = 'productTrends',
  UNIT_ECONOMICS = 'unitEconomics',
  CHOOSE_SALES_MODEL = 'chooseSalesModel',
  SELLER_PROFILE_SETUP = 'sellerProfileSetup',
  BONUSES = 'bonuses',
  ATTRACT_CUSTOMERS = 'attractCustomers',
}

export enum ECardLinks {
  ANALYTICS = 'analytics',
  CALCULATE = 'calculate',
  SALES_MODEL = 'salesModel',
  OPEN_STORE = 'openStore',
  PROMOTION_DETAILS = 'promotionDetails',
  SEARCH_ANALYTICS = 'searchAnalytics',
}

export type THowToStartConfig = {
  downloadPdf: string;
  titleWrapper: TTitleWrapper;
  cards: Array<TCard>;
  pdfLink: string;
};
